module.exports = __webpack_public_path__ + "static/media/021-ai.1bafb3c0.svg";